//Key (the sign-in tokens are HttpOnly cookies the page never sees)
import setToken from "../../util/setToken";
import setDevKey from "../../util/setDevKey";
import { secretKey } from "../../util/config";
import { getSession } from "../../util/authSession";

//Types
import {
  SET_ADMIN,
  UNSET_ADMIN,
  SET_LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_NAME,
  OPEN_ADMIN_TOAST,
  CLOSE_ADMIN_TOAST,
  FORGOT_PASSWORD,
  SET_CREATOR,
  SESSION_ENDED,
} from "./admin.type";

// Start from the stored (non-secret) session summary so a reload keeps the
// user on their page; App confirms it with GET /auth/session right after.
const storedSession = getSession();
if (storedSession) setDevKey(secretKey);

// The session summary from login / GET /auth/session / refresh. When it is the
// same account, keep the profile fields loaded since (UPDATE_PROFILE).
const sessionState = (state, session) => {
  if (!session || typeof session !== "object") return state;
  setDevKey(secretKey);
  localStorage.setItem("key", secretKey);
  const sameAccount = state.isAuth && state.admin?.adminId && state.admin.adminId === session.adminId;
  const admin = sameAccount ? { ...state.admin, ...session } : session;
  return {
    ...state,
    isAuth: true,
    admin,
    flag: admin,
  };
};

//Define initialStates
const initialState = {
  isAuth: Boolean(storedSession),
  admin: storedSession || {},
  toast: false,
  toastData: null,
  actionFor: null,
  password: {},
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    //Set admin (payload: session summary)
    case SET_ADMIN:
      return sessionState(state, action.payload);

    //Set creator (payload: session summary)
    case SET_CREATOR:
      return sessionState(state, action.payload);

    //session over (no local cleanup beyond the session summary)
    case SESSION_ENDED:
      return {
        ...state,
        isAuth: false,
        admin: {},
      };

    //unset admin
    case UNSET_ADMIN:
      window.localStorage.clear();
      setDevKey(null);
      setToken(null);
      return {
        ...state,
        isAuth: false,
        admin: {},
      };

    //Update admin Profile
    case UPDATE_PROFILE:
      return {
        ...state,
        admin: {
          ...state.admin,
          id: action.payload._id,
          adminId: action.payload._id || state.admin.adminId,
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          flag: action.payload.flag,
          role: action.payload.role || state.admin.role,
          permissions: Array.isArray(action.payload.permissions)
            ? action.payload.permissions
            : state.admin.permissions || [],
        },
      };

    //Update Admin Name
    case UPDATE_PROFILE_NAME:
      return {
        ...state,
        admin: action.payload,
      };

    //Open admin Toast
    case OPEN_ADMIN_TOAST:
      return {
        ...state,
        toast: true,
        toastData: action.payload.data || null,
        actionFor: action.payload.for || null,
      };

    //Close admin Toast
    case CLOSE_ADMIN_TOAST:
      return {
        ...state,
        toast: false,
        toastData: null,
        actionFor: null,
      };
    case FORGOT_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };

    default:
      return state;
  }
};

export default adminReducer;
